import React from 'react';
import ClientDepartmentDetail from '../Editors/ClientDepartmentDetail';
import ClientStaffList from './ClientStaffList';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tabs'
import ManageEntityList from './ManageEntityList';
import { useFormikContext } from 'formik';
import { ClientDepartmentMessageLog, ViewMessageLogModal } from './ViewMessageLog';
import { useEdit } from '../../Services/EditContext';
import { Route, Switch, useHistory, useParams } from 'react-router-dom';
import { useAuth } from '../../Services/AuthContext';

import CharterRequest from './CharterRequestsSupplier'
import ClientModal from '../Models/ClientModal';
import entities from '../../utils/entities';
import MarginDetails from '../Editors/MarginDetails';

const ClientDepartmentEditor = ({ route, item, entity, clientDepartmentId }) => {
    const { values } = useFormikContext();
    const { id } = values;
    const params = useParams();
    const { departmentAction } = params;
    const { push } = useHistory();
    const [edit] = useEdit();
    const [auth] = useAuth();

    
    const cid = id ?id: clientDepartmentId;
   
  

    return <React.Fragment><Tabs activeKey={departmentAction} onSelect={(key) => push(route + '/' + cid + '/'+key)}  style={{ height: '100%' }}>
        <Tab key={'Detail'} eventKey={'Detail'} title='Detail' >
            <ClientDepartmentDetail route={route + '/' + cid + '/' + departmentAction} item={item} edit={edit}/>
        </Tab>
        
        {!edit && <Tab key={'Staff'} eventKey={'Staff'} title='Staff' style={{ height: '400px' }} >
            {departmentAction === "Staff" && <ClientStaffList route={route + '/' + cid + '/' + departmentAction} item={{ ...values, client: item }} clientStaffId={id} parentHeight={400} headerHeight={60} />}
        </Tab>
        }
        {!edit && <Tab key={'Charters'} eventKey={'Charters'} title='Charters' style={{ height: '400px' }} >
            {departmentAction === 'Charters' && <CharterRequest area='department' route={route + '/' + cid + '/' + departmentAction} item={{ ...values, client: item }} parentHeight={400} />}
        </Tab>}
        {auth && auth.role === 'Admin' && !edit && <Tab key={'Margin'} eventKey={'Margin'} title='Margin' style={{ height: '400px' }} >
            {departmentAction === 'Margin' ? <MarginDetails id={id} route={route + '/' + id + '/' + departmentAction} item={values} parentHeight={400} /> : null}
        </Tab>}
        {!edit && <Tab key={'Messages'} eventKey={'Messages'} title='Messages' style={{ height: '400px' }} >
            {departmentAction === "Messages" && <ClientDepartmentMessageLog item={{ ...values, client: item }} itemParam='clientStaffId' route={route + '/' + cid + '/' + departmentAction} clientDepartmentId={id} parentHeight={400} headerHeight={60} />}
        </Tab>
        }
    </Tabs >
        <Switch>

            <Route path={route + '/' + clientDepartmentId + '/Messages/:messageId'} render={() =>
                <ViewMessageLogModal />
            } />

            <Route path={route + '/' + clientDepartmentId + '/Charters/:list/:activeKey/:charterRequestId'} render={()=>
                <ClientModal route={route} entity={entity} itemParam='charterRequestId' > <CharterRequest entity={entity} route={route} /></ClientModal>
            } />



        </Switch>
    </React.Fragment>
}

const ClientDepartmentList = ({ hideActions,admin, route, parentHeight, headerHeight, item }) => {
    const [auth] = useAuth();
    const entity = admin ? entities.clientDepartmentAdmin : entities.clientDepartment;
    const params = useParams(); 
    const newRoute = admin && params.clientId ? route + params.clientId+ '/'+ params.clientAction+'/'+params.list : route; 
    return <React.Fragment>
        <ManageEntityList hideActions={hideActions} route={route} item={item ? item : { id: auth.clientId }} id={auth.clientId} entity={entity} headerHeight={headerHeight} parentHeight={parentHeight} />
        <Switch>
            <Route path={newRoute + '/:clientDepartmentId/:departmentAction/:list/:activeKey'} render={() =>
                <ClientModal entity={entity} route={route} itemParam='clientDepartmentId'><ClientDepartmentEditor route={route} /></ClientModal>}/>
            <Route path={newRoute + '/:clientDepartmentId/:departmentAction/:list'} render={() =>
                <ClientModal entity={entity} route={route} itemParam='clientDepartmentId'><ClientDepartmentEditor route={route} /></ClientModal>}/>
            <Route path={newRoute + '/:clientDepartmentId/:departmentAction'} render={() =>
                <ClientModal entity={entity} route={route} itemParam='clientDepartmentId'><ClientDepartmentEditor route={route} /></ClientModal>}/>
            <Route path={newRoute + '/:clientDepartmentId'} render={() =>
                <ClientModal entity={entity} route={route} itemParam='clientDepartmentId'><ClientDepartmentEditor route={route} /></ClientModal>}/>
        </Switch>
    </React.Fragment>
} 
export default ClientDepartmentList;
